<p-dialog [(visible)]="displayPastListsDialog" [focusOnShow]="false" [style]="{width: '620px'}"
          dismissableMask="true"
          header="Download past multicast lists" modal="true">
  <div *ngIf="researchForm" [formGroup]="researchForm">
    <p>Select a range of dates and click 'Download'. Only dates with a published multicast list are selectable.</p>
    <div class="past-range-controls">
      <label class="mb-0" for="past_date_filter_range_1">From date:</label>
      <p-calendar
        [disabledDates]="disabledDatesInCalendar"
        appendTo="body"
        formControlName="pastDateRange1"
        id="past_date_filter_range_1"
        panelStyleClass="sym-datepicker">
        <ng-template let-date pTemplate="date">
          <span [ngStyle]="{'color': '#2563eb', 'textDecoration': 'underline' }">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
      <label class="mb-0" for="past_date_filter_range_2">To date:</label>
      <p-calendar
        [disabledDates]="disabledDatesInCalendar"
        appendTo="body"
        formControlName="pastDateRange2"
        id="past_date_filter_range_2"
        panelStyleClass="sym-datepicker">
        <ng-template let-date pTemplate="date">
          <span [ngStyle]="{'color': '#2563eb', 'textDecoration': 'underline' }">{{ date.day }}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button (click)="resetRangeDates()"
            icon="fa fa-refresh pr-2"
            iconPos="left"
            label="Reset"
            pButton
            type="button"></button>
    <button (click)="downloadRangeQedMulticastList()"
            [disabled]="rangeDateNotSelected()"
            icon="fa fa-download pr-2"
            iconPos="left"
            id="download_past_file_with_date_range_button"
            label="Download"
            pButton
            type="button"></button>
  </ng-template>
</p-dialog>
<div class="symbols-title-row">
  <h3 class="mb-0">
    <b>{{ isQhf ? 'Volume Signals (QHF): multicasts' : 'Snapshot: multicasts' }}</b>
  </h3>
  <div class="symbols-title-meta">
    <span *ngIf="getCommentFromQedSymbolInfoData()">{{ getCommentFromQedSymbolInfoData() }}</span>
    <span *ngIf="updateOnDate">Updated on: {{ updateOnDate | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
  </div>
</div>
<div *ngIf="alertQedSymbolHasNotChanged " class="alert alert-danger alert-dismissible fade show">
  This information is outdated. Please verify that the {{ isQhf ? 'Volume Signals (QHF)' : 'snapshot (QED)' }}
  Multicast list has not changed.
</div>
<div *ngIf="!alertQedSymbolHasNotChanged && researchForm" [formGroup]="researchForm">
  <div class="symbols-filter">
    <label class="symbols-filter-label mb-0" for="pop_filter">POP</label>
    <p-dropdown
      (onChange)="filterMulticastList()"
      [filter]="true"
      [options]="popOptions"
      [showClear]="true"
      formControlName="pop"
      id="pop_filter"
      placeholder="All POPs">
    </p-dropdown>
    <label class="symbols-filter-label mb-0" for="channel_filter">Channel</label>
    <input (input)="filterMulticastList()" class="form-control symbols-filter-input" formControlName="channel"
           id="channel_filter" placeholder="Filter…" type="text">
    <label class="symbols-filter-label mb-0" for="ip_address_1_filter">IP address</label>
    <div class="symbols-ip-group">
      <input (input)="filterMulticastList()" (paste)="onPasteIp($event)"
             class="form-control symbols-filter-input symbols-ip-input" formControlName="ipAddress1"
             id="ip_address_1_filter" type="text">
      <span class="symbols-ip-dot">.</span>
      <input (input)="filterMulticastList()" class="form-control symbols-filter-input symbols-ip-input"
             formControlName="ipAddress2" id="ip_address_2_filter" type="text">
      <span class="symbols-ip-dot">.</span>
      <input (input)="filterMulticastList()" class="form-control symbols-filter-input symbols-ip-input"
             formControlName="ipAddress3" id="ip_address_3_filter" type="text">
      <span class="symbols-ip-dot">.</span>
      <input (input)="filterMulticastList()" class="form-control symbols-filter-input symbols-ip-input"
             formControlName="ipAddress4" id="ip_address_4_filter" type="text">
    </div>
    <label class="symbols-filter-label mb-0" for="platform_filter">Platform</label>
    <select (change)="filterMulticastList()" class="custom-select symbols-filter-select" formControlName="platform"
            id="platform_filter">
      <option *ngFor="let platform of platformOptions"
              [attr.selected]="platformForm.value == platform ? true : null">{{ platform }}
      </option>
    </select>
    <label class="symbols-filter-label mb-0" for="encryption_filter">Encryption</label>
    <select (change)="filterMulticastList()" class="custom-select symbols-filter-select" formControlName="encryption"
            id="encryption_filter">
      <option *ngFor="let encryption of encryptionOptions"
              [attr.selected]="encryptionForm.value == encryption ? true : null">{{ encryption }}
      </option>
    </select>
    <label class="symbols-filter-label mb-0" for="protection_filter">Protection</label>
    <select (change)="filterMulticastList()" class="custom-select symbols-filter-select" formControlName="protection"
            id="protection_filter">
      <option *ngFor="let protection of protectionOptions"
              [attr.selected]="protectionForm.value == protection ? true : null">{{ protection }}
      </option>
    </select>
    <div class="symbols-filter-right">
      <button (click)="downloadMenu.toggle($event)" icon="fa fa-download pr-2" iconPos="left"
              id="download_csv_menu_button" label="Download CSV" pButton type="button"></button>
      <button (click)="resetTable()" icon="fa fa-refresh pr-2" iconPos="left" id="reset_button"
              label="Reset" pButton type="button"></button>
    </div>
  </div>
  <p-overlayPanel #downloadMenu styleClass="sym-download-menu">
    <div class="symbols-menu">
      <button (click)="downloadCurrentQedMulticastList(); downloadMenu.hide()" class="symbols-menu-item"
              id="download_current_qrd_symbol_list" type="button">
        <i aria-hidden="true" class="fa fa-download"></i>This week's multicast list
      </button>
      <ng-container *ngIf="startDates">
        <div class="symbols-menu-sep"></div>
        <button (click)="displayPastListsDialog = true; downloadMenu.hide()" class="symbols-menu-item"
                id="past_lists_menu_item" type="button">
          <i aria-hidden="true" class="fa fa-calendar"></i>Past multicast lists…
        </button>
      </ng-container>
    </div>
  </p-overlayPanel>
  <div>
    <div *ngIf="filteredQedMulticastList.length === 0">
      <p class="symbols-empty-note">No data found for Multicast Groups definition</p>
    </div>
    <div *ngIf="filteredQedMulticastList.length !== 0" class="symbols-market-table symbols-grid-table">
      <p-table [rowHover]="true" [tableStyle]="{'table-layout':'auto'}" [value]="filteredQedMulticastList"
               id="qed-multicast-table">
        <ng-template pTemplate="caption">
          Multicast Groups definition
          <span class="symbols-table-count">{{ filteredQedMulticastList.length }} channels</span>
        </ng-template>
        <ng-template let-columns pTemplate="header">
          <tr>
            <th class="mc-pop-col" rowspan="3">POP</th>
            <th rowspan="3">Channel</th>
            <th *ngIf="encryptionForm.value !== 'Encrypted'" [attr.colspan]="colspanEncryptionColumn()">Non-encrypted
            </th>
            <th *ngIf="encryptionForm.value !== 'Non-Encrypted'" [attr.colspan]="colspanEncryptionColumn()">Encrypted
            </th>
          </tr>
          <tr>
            <th *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted'"
                [attr.colspan]="colspanProductionColumn()">Protected
            </th>
            <th *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted'"
                [attr.colspan]="colspanProductionColumn()">Non Protected
            </th>
            <th *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted'"
                [attr.colspan]="colspanProductionColumn()">Protected
            </th>
            <th *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted'"
                [attr.colspan]="colspanProductionColumn()">Non Protected
            </th>
          </tr>
          <tr>
            <th
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'UAT only'">
              Prod / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'Prod only'">
              UAT / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'UAT only'">
              Prod / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'Prod only'">
              UAT / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'UAT only'">
              Prod / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'Prod only'">
              UAT / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'UAT only'">
              Prod / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'Prod only'">
              UAT / Port
            </th>
          </tr>
        </ng-template>
        <ng-template [ngForOf]="filteredQedMulticastList" let-qedMulticast ngFor pTemplate="body">
          <tr>
            <td *ngIf="channelsWithSamePop(qedMulticast.pop)[0]?.channel === qedMulticast.channel"
                [attr.rowspan]="channelsWithSamePop(qedMulticast.pop)?.length"
                class="mc-pop-col"
                style="vertical-align: top">{{ qedMulticast.pop }}
            </td>
            <td class="mc-channel-col">{{ qedMulticast.channel }}</td>
            <td
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'UAT only'">{{ qedMulticast.nonCryptProtProd }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'Prod only'">{{ qedMulticast.nonCryptProtUat }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'UAT only'">{{ qedMulticast.nonCryptNonProtProd }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'Prod only'">{{ qedMulticast.nonCryptNonProtUat }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'UAT only'">{{ qedMulticast.cryptProtProd }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'Prod only'">{{ qedMulticast.cryptProtUat }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'UAT only'">{{ qedMulticast.cryptNonProtProd }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'Prod only'">{{ qedMulticast.cryptNonProtUat }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div *ngIf="filteredValuesArbitrated.length === 0">
      <p class="symbols-empty-note">No data found for Arbitration feeds</p>
    </div>
    <div *ngIf="filteredValuesArbitrated.length !== 0" class="symbols-market-table symbols-grid-table">
      <p-table [rowHover]="true" [tableStyle]="{'table-layout':'auto'}"
               [value]="filteredValuesArbitrated" id="qed-arbitrated-multicast-table">
        <ng-template pTemplate="caption">
          Arbitration feeds*
          <span class="symbols-table-count">{{ filteredValuesArbitrated.length }} channels</span>
        </ng-template>
        <ng-template let-columns pTemplate="header">
          <tr>
            <th class="mc-pop-col" rowspan="3">POP</th>
            <th rowspan="3">Channel</th>
            <th *ngIf="encryptionForm.value !== 'Encrypted'" [attr.colspan]="colspanEncryptionColumn()">Non-encrypted
            </th>
            <th *ngIf="encryptionForm.value !== 'Non-Encrypted'" [attr.colspan]="colspanEncryptionColumn()">Encrypted
            </th>
          </tr>
          <tr>
            <th *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted'"
                [attr.colspan]="colspanProductionColumn()">Protected
            </th>
            <th *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted'"
                [attr.colspan]="colspanProductionColumn()">Non Protected
            </th>
            <th *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted'"
                [attr.colspan]="colspanProductionColumn()">Protected
            </th>
            <th *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted'"
                [attr.colspan]="colspanProductionColumn()">Non Protected
            </th>
          </tr>
          <tr>
            <th
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'UAT only'">
              Prod / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'Prod only'">
              UAT / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'UAT only'">
              Prod / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'Prod only'">
              UAT / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'UAT only'">
              Prod / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'Prod only'">
              UAT / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'UAT only'">
              Prod / Port
            </th>
            <th
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'Prod only'">
              UAT / Port
            </th>
          </tr>
        </ng-template>
        <ng-template [ngForOf]="filteredValuesArbitrated" let-qedArbitratedMulticast ngFor pTemplate="body">
          <tr>
            <td
              *ngIf="channelsWithSamePop(qedArbitratedMulticast.pop, true)[0]?.channel === qedArbitratedMulticast.channel"
              [attr.rowspan]="channelsWithSamePop(qedArbitratedMulticast.pop, true)?.length"
              class="mc-pop-col"
              style="vertical-align: top">{{ qedArbitratedMulticast.pop }}
            </td>
            <td class="mc-channel-col">{{ qedArbitratedMulticast.channel }}</td>
            <td
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'UAT only'">{{ qedArbitratedMulticast.nonCryptProtProd }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'Prod only'">{{ qedArbitratedMulticast.nonCryptProtUat }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'UAT only'">{{ qedArbitratedMulticast.nonCryptNonProtProd }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Encrypted' && platformForm.value !== 'Prod only'">{{ qedArbitratedMulticast.nonCryptNonProtUat }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'UAT only'">{{ qedArbitratedMulticast.cryptProtProd }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Non-Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'Prod only'">{{ qedArbitratedMulticast.cryptProtUat }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'UAT only'">{{ qedArbitratedMulticast.cryptNonProtProd }}
            </td>
            <td
              *ngIf="protectionForm.value !== 'Protected' && encryptionForm.value !== 'Non-Encrypted' && platformForm.value !== 'Prod only'">{{ qedArbitratedMulticast.cryptNonProtUat }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="symbols-footnote">* These feeds are provided for arbitration only and have higher latency than the
      standard feeds.
    </div>
  </div>
</div>
